module.exports = __webpack_public_path__ + "static/media/00_paint_agd-final-fantasy.27c65cbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/00_paint_agd-final-fantasy.jpg
// module id = 266
// module chunks = 0